/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ProcessingState } from "./ProcessingState";
import {
  ProcessingStateFromJSON,
  ProcessingStateFromJSONTyped,
  ProcessingStateToJSON,
  ProcessingStateToJSONTyped,
} from "./ProcessingState";

/**
 *
 * @export
 * @interface Task
 */
export interface Task {
  /**
   *
   * @type {string}
   * @memberof Task
   */
  taskId: string;
  /**
   *
   * @type {string}
   * @memberof Task
   */
  taskType: string;
  /**
   *
   * @type {string}
   * @memberof Task
   */
  taskKey: string;
  /**
   *
   * @type {string}
   * @memberof Task
   */
  groupKey?: string | null;
  /**
   *
   * @type {string}
   * @memberof Task
   */
  payload: string;
  /**
   *
   * @type {ProcessingState}
   * @memberof Task
   */
  state: ProcessingState;
  /**
   *
   * @type {number}
   * @memberof Task
   */
  priority: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Task
   */
  scheduledAt: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof Task
   */
  claimedBy?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Task
   */
  claimedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Task
   */
  startedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Task
   */
  heartbeatAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Task
   */
  completedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof Task
   */
  errorMessage?: string | null;
  /**
   *
   * @type {number}
   * @memberof Task
   */
  attemptCount: number;
  /**
   *
   * @type {number}
   * @memberof Task
   */
  maxAttempts: number;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof Task
   */
  createdAt: OffsetDateTime;
}

/**
 * Check if a given object implements the Task interface.
 */
export function instanceOfTask(value: object): value is Task {
  if (!("taskId" in value) || value["taskId"] === undefined) return false;
  if (!("taskType" in value) || value["taskType"] === undefined) return false;
  if (!("taskKey" in value) || value["taskKey"] === undefined) return false;
  if (!("payload" in value) || value["payload"] === undefined) return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  if (!("priority" in value) || value["priority"] === undefined) return false;
  if (!("scheduledAt" in value) || value["scheduledAt"] === undefined)
    return false;
  if (!("attemptCount" in value) || value["attemptCount"] === undefined)
    return false;
  if (!("maxAttempts" in value) || value["maxAttempts"] === undefined)
    return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  return true;
}

export function TaskFromJSON(json: any): Task {
  return TaskFromJSONTyped(json, false);
}

export function TaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Task {
  if (json == null) {
    return json;
  }
  return {
    taskId: json["taskId"],
    taskType: json["taskType"],
    taskKey: json["taskKey"],
    groupKey: json["groupKey"] == null ? undefined : json["groupKey"],
    payload: json["payload"],
    state: ProcessingStateFromJSON(json["state"]),
    priority: json["priority"],
    scheduledAt: json["scheduledAt"],
    claimedBy: json["claimedBy"] == null ? undefined : json["claimedBy"],
    claimedAt: json["claimedAt"] == null ? undefined : json["claimedAt"],
    startedAt: json["startedAt"] == null ? undefined : json["startedAt"],
    heartbeatAt: json["heartbeatAt"] == null ? undefined : json["heartbeatAt"],
    completedAt: json["completedAt"] == null ? undefined : json["completedAt"],
    errorMessage:
      json["errorMessage"] == null ? undefined : json["errorMessage"],
    attemptCount: json["attemptCount"],
    maxAttempts: json["maxAttempts"],
    createdAt: json["createdAt"],
  };
}

export function TaskToJSON(json: any): Task {
  return TaskToJSONTyped(json, false);
}

export function TaskToJSONTyped(
  value?: Task | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    taskId: value["taskId"],
    taskType: value["taskType"],
    taskKey: value["taskKey"],
    groupKey: value["groupKey"],
    payload: value["payload"],
    state: ProcessingStateToJSON(value["state"]),
    priority: value["priority"],
    scheduledAt: value["scheduledAt"],
    claimedBy: value["claimedBy"],
    claimedAt: value["claimedAt"],
    startedAt: value["startedAt"],
    heartbeatAt: value["heartbeatAt"],
    completedAt: value["completedAt"],
    errorMessage: value["errorMessage"],
    attemptCount: value["attemptCount"],
    maxAttempts: value["maxAttempts"],
    createdAt: value["createdAt"],
  };
}
